import { Injectable, Optional, SkipSelf } from '@angular/core';
import { AbpHttpConfigurationService, LogService, MessageService, IErrorInfo } from 'abp-ng2-module';
import { Router } from '@angular/router';
import { throwError, Observable } from 'rxjs';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ZeroTemplateHttpConfigurationService extends AbpHttpConfigurationService {

    constructor(
        messageService: MessageService,
        logService: LogService,
        private _route: Router) {
        
        super(messageService, logService);
    }
    static disableError: boolean;
    // Override handleUnAuthorizedRequest so it doesn't refresh the page during failed login attempts.
    handleUnAuthorizedRequest(messagePromise: any, targetUrl?: string) {
        if (this._route.url === '/account/login') {
            return;
        }

        const self = this;

        if (messagePromise) {
            messagePromise.done(() => {
                this.handleTargetUrl(targetUrl || '/');
            });
        } else {
            self.handleTargetUrl(targetUrl || '/');
        }
    }
    showError(error: IErrorInfo) {
        if (!ZeroTemplateHttpConfigurationService.disableError) {
            super.showError(error);
        } else {
            ZeroTemplateHttpConfigurationService.disableError = false;
        }
    }
}
